import styled from "@emotion/styled/macro";
//import { format, differenceInYears } from "date-fns";
import React, { useState } from "react";
import ReactGA from "react-ga";

import DialogPortal from "../common/DialogPortal";
import DialogRoot from "../common/DialogRoot";
import Button from "../common/Button";

import { IUser } from "../ApiService";
import { IBobblehead } from "../App";
import FormField from "../common/FormField";
import TextInput from "../common/TextInput";
import TeamLogoRays from "../res/Tampa_Bay_Rays.svg"
import teamLogoMets from "../res/Mets_Word_Mark_Transparent.png";
import MainIndex, { bobbleHeadID } from "../index";

//import PlayFab from "../Playfab/PlayFab";
import ApiService from "../ApiService";

const Root = styled(DialogRoot)`
  width: 340px;
  position: relative;
  padding: 50px 40px 42px;
  font-size: 14px;
`;

const Icon = styled<"div", { logo: string }>("div")`
  width: 80px;
  height: 80px;
  background: url(${({ logo }) => logo}) no-repeat center center #edf0f6;
  background-size: 50px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SubmitButton = styled(Button)`
  width: 88%;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(50%);
`;

/*const Error = styled("div")`
  color: #fff;
  background-color: #cb3d3d;
  text-align: center;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: bold;
  line-height: 2;
  margin-top: 12px;
`;*/

/*const DateInput = styled(TextInput)`
  width: 100%;
`;*/

interface IProps {
  signedInUser: IUser;
  bobblehead: IBobblehead;
  onClose: () => void;
  onSuccess: (email: string) => void;
}

function isValidEmail(email: string) {
  var re = /^(([^<>()[\]\.,;:\s@"]+(\.[^<>()[\]\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

/*function getValidDate(date: string): Date | null {
  try {
    return new Date(date);
  } catch (e) {
    return null;
  }
}*/

export default function GetMyBonusDialog({
  bobblehead,
  onClose,
  onSuccess
}: IProps) {
  const [email, setEmail] = useState("");
  const [emailChanged, setEmailChanged] = useState(false);
  const [emailBlurred, setEmailBlurred] = useState(false);
  //const [dateOfBirth, setDateOfBirth] = useState("");
  //const [dateOfBirthChanged, setDateOfBirthChanged] = useState(false);
  //const [dateOfBirthBlurred, setDateOfBirthBlurred] = useState(false);
  const [isSending, setIsSending] = useState(false);
  //const [showAgeError, setShowAgeError] = useState(false);

  const emailIsValid = isValidEmail(email);
  //const parsedDate = getValidDate(dateOfBirth);
  //const dateOfBirthIsValid = !!parsedDate && parsedDate.getFullYear() > 1900;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    /*if (!emailIsValid) {
      return;
    }*/

    /*const age = differenceInYears(new Date(), parsedDate);
    if (age < 13) {
      setShowAgeError(true);
      return;
    }*/

    setIsSending(true);

    ReactGA.event({
      category: "sign up",
      action: "submit login info",
      label: "email"
    });

    //const dateOfBirth = format(parsedDate, "MM/DD/YYYY");
    try {
      const logInResult = await ApiService.relogIn(email);
      if (!logInResult) {
        setIsSending(false);
      } else {
        try {
          //console.log("setting return user");
          //PlayFab.SetBirth(dateOfBirth);
          //PlayFab.SetZip(zipCode);
          //PlayFab.DoExampleLoginWithCustomIDReal(phoneNumber);
        } catch (e) {
          console.error("Error signing in", e);
        }
        onSuccess(logInResult.email);
      }
    } catch (e) {
      console.error(e);
      setIsSending(false);
    }
      // TODO: Save results from form
      //console.log(parsedDate.toString());
      //console.log(email);
      //PlayFab.SetBirth(parsedDate.toString());
      //PlayFab.SetContactEmail(email);
      //PlayFab.ReturnUserLogin(email);
      //onSuccess(email);
    //} catch (e) {
      //console.error(e);
      //setIsSending(false);
    //}
  };

  if(bobbleHeadID === "M0") {
    return (
      <DialogPortal onClose={onClose}>
        <Root hasLogo={true}>
          <Icon logo={teamLogoMets} />
          <form onSubmit={handleSubmit}>
            <p>
              Returning user? Enter your email address to log in.
            </p>
            <FormField>
              <label>Email</label>
              <TextInput
                type="email"
                value={email}
                center
                autoFocus
                placeholder="email@provider.com"
                onChange={e => {
                  setEmail(e.target.value);
                  setEmailChanged(true);
                }}
                onBlur={e => {
                  setEmailBlurred(true);
                }}
                isValid={!email || !emailChanged || !emailBlurred || emailIsValid}
              />
            </FormField>
            {/*<FormField>
              <label>Birthdate</label>
              <DateInput
                type="date"
                placeholder="mm/dd/yyyy"
                value={dateOfBirth}
                center
                min="1900-01-01"
                onChange={e => {
                  setDateOfBirth(e.target.value);
                  setDateOfBirthChanged(true);
                }}
                onBlur={e => {
                  setShowAgeError(false);
                  setDateOfBirthBlurred(true);
                }}
                isValid={
                  !showAgeError &&
                  (!dateOfBirth ||
                    !dateOfBirthChanged ||
                    !dateOfBirthBlurred ||
                    dateOfBirthIsValid)
                }
              />
              </FormField>*/}
            {/*{showAgeError && <Error>You are not old enough</Error>}*/}
            <SubmitButton
              onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
              disabled={isSending || !emailIsValid}
            >
              Log In
            </SubmitButton>
          </form>
        </Root>
      </DialogPortal>
    );
  } else {
    return (
      <DialogPortal onClose={onClose}>
        <Root hasLogo={true}>
          <Icon logo={TeamLogoRays} />
          <form onSubmit={handleSubmit}>
            <p>
              Returning user? Enter your email address to log in.
            </p>
            <FormField>
              <label>Email</label>
              <TextInput
                type="email"
                value={email}
                center
                autoFocus
                placeholder="email@provider.com"
                onChange={e => {
                  setEmail(e.target.value);
                  setEmailChanged(true);
                }}
                onBlur={e => {
                  setEmailBlurred(true);
                }}
                isValid={!email || !emailChanged || !emailBlurred || emailIsValid}
              />
            </FormField>
            {/*<FormField>
              <label>Birthdate</label>
              <DateInput
                type="date"
                placeholder="mm/dd/yyyy"
                value={dateOfBirth}
                center
                min="1900-01-01"
                onChange={e => {
                  setDateOfBirth(e.target.value);
                  setDateOfBirthChanged(true);
                }}
                onBlur={e => {
                  setShowAgeError(false);
                  setDateOfBirthBlurred(true);
                }}
                isValid={
                  !showAgeError &&
                  (!dateOfBirth ||
                    !dateOfBirthChanged ||
                    !dateOfBirthBlurred ||
                    dateOfBirthIsValid)
                }
              />
              </FormField>*/}
            {/*{showAgeError && <Error>You are not old enough</Error>}*/}
            <SubmitButton
              onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
              disabled={isSending || !emailIsValid}
            >
              Log In
            </SubmitButton>
          </form>
        </Root>
      </DialogPortal>
    );
  }
}
